<template>
	<section>
		<div v-if="status == 'insert'" class="alert alert-success alert-dismissible fade show success f-12" role="alert"> <span><i class="fas fa-check-circle mr-2"></i></span>Data berhasil ditambahkan
			<button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span>
			</button>
		</div>

		<div v-if="status == 'delete' || isDelete" class="alert alert-danger alert-dismissible fade show danger f-12" role="alert"> <span><i class="fas fa-trash-alt mr-2"></i></span>Data berhasil dihapus
			<button type="button" class="close" @click="isDelete = false" aria-label="Close"> <span aria-hidden="true">&times;</span>
			</button>
		</div>

		<div v-if="status == 'update'" class="alert alert-primary alert-dismissible fade show primary f-12" role="alert"> <span><i class="fas fa-check-circle mr-2"></i></span>Data berhasil diubah
			<button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span>
			</button>
		</div>
	</section>
</template>

<script>
import { EventBus } from '@/plugins/bus.js'
export default {
	name: 'Alert',
	props: ['status'],
	data() {
		return {
			isDelete: false
		}
	},
	mounted() {
		let _ = this
		EventBus.$on('deleteEvent', (resp) => {
			if ( resp ) {
				_.isDelete = true
			}
		});
	}
}
</script>